import dynamic from 'next/dynamic';
import React, { FC } from 'react';

import { ContextModalProps } from '@mantine/modals';

import { Zone } from 'models';

const ZoneDroopCurvesModalLazy = dynamic(() => import('./ZoneDroopCurvesModalLazy'), {
    ssr: false,
});

const ZoneDroopCurvesModal: FC<
    ContextModalProps<{
        zone: Zone;
    }>
> = ({ innerProps, ...rest }) => {
    return <ZoneDroopCurvesModalLazy innerProps={innerProps} {...rest} />;
};

export { ZoneDroopCurvesModal };
